import Vue from 'vue'
import App from './App.vue'
import axios from "axios"
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import store from './store'
import router from './router'
import IframeService from './services/iframe'

import VueI18n from 'vue-i18n'
import i18nMessages from './i18n/messages'
import i18nDateTimes from './i18n/dateTimes'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: i18nMessages,
  dateTimeFormats: i18nDateTimes
})

import { BootstrapVue, IconsPlugin } from "bootstrap-vue"

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueLodash, { lodash: lodash })

Vue.prototype.$http = axios

import dayjs from 'dayjs'
dayjs.extend(require('dayjs/plugin/duration'))
dayjs.extend(require('dayjs/plugin/isSameOrAfter'))
dayjs.extend(require('dayjs/plugin/isSameOrBefore'))
const daysjsFrLocale = require('dayjs/locale/fr')
dayjs.locale(daysjsFrLocale)
const localizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.extend(localizedFormat)
Vue.prototype.$dayjs = dayjs

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
// En iframe pleine hauteur, un centrage vertical placerait les alertes au milieu
// de tout le contenu, hors du viewport de la page hôte
Vue.use(VueSweetalert2, IframeService.isEmbedded() ? { position: 'top' } : {})

if (IframeService.isEmbedded()) {
  document.body.classList.add('mp-embedded')
}

import * as Resize from 'iframe-resizer/js/iframeResizer.contentWindow'
Vue.use(Resize)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
